// Color palettes
const colors = {
  dark: {
    bg: "#0d1117",
    bgCard: "#161b22",
    bgInput: "#21262d",
    border: "#30363d",
    text: "#e6edf3",
    textSecondary: "#8b949e",
    accent: "#f0a500",
    accentBorder: "#a16800",
    accentBg: "rgba(240,165,0,.12)",
    error: "#f85149",
    errorBg: "rgba(248,81,73,.12)",
    errorBorder: "rgba(248,81,73,.25)",
    info: "#58a6ff",
    infoBg: "rgba(56,139,253,.12)",
    infoBorder: "rgba(56,139,253,.25)",
    success: "#3fb950",
    successBg: "rgba(63,185,80,.06)",
    successBorder: "rgba(63,185,80,.3)",
    purple: "#a78bfa",
    purpleBg: "rgba(139,92,246,.12)",
    shadow: "rgba(0,0,0,.4)",
    overlay: "rgba(0,0,0,.8)",
    badge: "#30363d",
  },
  light: {
    bg: "#ffffff",
    bgCard: "#f6f8fa",
    bgInput: "#ffffff",
    border: "#d0d7de",
    text: "#24292f",
    textSecondary: "#57606a",
    accent: "#d48a00",
    accentBorder: "#bf8700",
    accentBg: "rgba(212,138,0,.10)",
    error: "#cf222e",
    errorBg: "rgba(207,34,46,.08)",
    errorBorder: "rgba(207,34,46,.25)",
    info: "#0969da",
    infoBg: "rgba(9,105,218,.08)",
    infoBorder: "rgba(9,105,218,.25)",
    success: "#1a7f37",
    successBg: "rgba(26,127,55,.06)",
    successBorder: "rgba(26,127,55,.3)",
    purple: "#8250df",
    purpleBg: "rgba(130,80,223,.10)",
    shadow: "rgba(0,0,0,.12)",
    overlay: "rgba(0,0,0,.5)",
    badge: "#e1e4e8",
  }
};

// Build full theme object from a color palette
function buildTheme(c) {
  return {
    colors: c,
    inp: {
      background: c.bgInput,
      border: "1px solid " + c.border,
      color: c.text,
      padding: "7px 10px",
      borderRadius: 3,
      width: "100%",
      fontSize: 12,
      outline: "none",
      fontFamily: "inherit"
    },
    sel: {
      background: c.bgInput,
      border: "1px solid " + c.border,
      color: c.text,
      padding: "7px 10px",
      borderRadius: 3,
      width: "100%",
      fontSize: 12,
      outline: "none",
      fontFamily: "inherit"
    },
    card: {
      background: c.bgCard,
      border: "1px solid " + c.border,
      borderRadius: 4,
      padding: 18,
      marginBottom: 12
    },
    btnP: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      background: c.accent,
      color: "#000",
      border: "none",
      padding: "4px 10px",
      borderRadius: 5,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 11,
      fontFamily: "inherit",
      boxShadow: "0 1px 2px rgba(0,0,0,0.07)",
      transition: "opacity 0.15s"
    },
    btnG: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      background: "transparent",
      color: c.text,
      border: "1px solid " + c.border,
      padding: "4px 10px",
      borderRadius: 5,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 11,
      fontFamily: "inherit",
      boxShadow: "0 1px 2px rgba(0,0,0,0.07)",
      transition: "opacity 0.15s"
    },
    btnSm: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      background: c.accent,
      color: "#000",
      border: "none",
      padding: "3px 8px",
      borderRadius: 5,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 10,
      fontFamily: "inherit",
      boxShadow: "0 1px 2px rgba(0,0,0,0.07)",
      transition: "opacity 0.15s"
    },
    btnDanger: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      background: "#dc2626",
      color: "#fff",
      border: "none",
      padding: "4px 10px",
      borderRadius: 5,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 11,
      fontFamily: "inherit",
      boxShadow: "0 1px 2px rgba(0,0,0,0.07)",
      transition: "opacity 0.15s"
    },
    btnEdit: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      background: "transparent",
      color: c.info,
      border: "1px solid " + c.infoBorder,
      padding: "4px 10px",
      borderRadius: 5,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 11,
      fontFamily: "inherit",
      boxShadow: "0 1px 2px rgba(0,0,0,0.07)",
      transition: "opacity 0.15s"
    },
    label: {
      fontSize: 10,
      color: c.textSecondary,
      display: "block",
      marginBottom: 4,
      fontFamily: "monospace",
      letterSpacing: 0.5
    },
    mono: {
      fontFamily: "monospace"
    },
    sectTag: {
      background: c.accentBg,
      border: "1px solid " + c.accentBorder,
      color: c.accent,
      fontSize: 9,
      padding: "3px 8px",
      borderRadius: 2,
      letterSpacing: 2,
      fontFamily: "monospace"
    },
    th: {
      textAlign: "left",
      padding: "7px 10px",
      fontSize: 9,
      fontFamily: "monospace",
      color: c.textSecondary,
      letterSpacing: 1,
      borderBottom: "1px solid " + c.border,
      background: c.bgInput,
      whiteSpace: "nowrap"
    },
    td: {
      padding: "7px 10px",
      borderBottom: "1px solid " + c.border,
      fontSize: 12
    }
  };
}

// Pre-built themes
export const darkTheme = buildTheme(colors.dark);
export const lightTheme = buildTheme(colors.light);

// Helper to get theme by mode
export function getTheme(mode) {
  return mode === "light" ? lightTheme : darkTheme;
}

// Default export for backward compatibility during migration
export const theme = darkTheme;
